/* eslint-disable unused-imports/no-unused-vars */
import { css } from '@emotion/react';
import { Theme } from '../../../config/theme';

export default (theme: Theme) => ({
  backButton: css`
    position: absolute;
    top: 0;
    left: 0;
    padding: ${theme.spacing.large};
    align-self: center;
    cursor: pointer;
    width: 32px;
    &:hover {
      opacity: 0.6;
    }
  `,
});
